module.exports = __webpack_public_path__ + "img/img4.dc8c795e.jpg";